import { createJSONStorage } from 'jotai/utils';

/**
 * SSR-safe JSON storage factory for `atomWithStorage`. During server render
 * there is no `window`, so reads short-circuit to the atom's initial value and
 * writes are no-ops.
 */
export const createSsrSafeStorage = <T>() =>
  createJSONStorage<T>(() => {
    if (typeof window === 'undefined') {
      return {
        getItem: () => null,
        setItem: () => undefined,
        removeItem: () => undefined,
      };
    }
    return window.localStorage;
  });
